/**
 * unpushedReason — why an Apply answered without pushing anything, or null.
 * The backend answers a blocked Apply (kill switch, Tres Commas switch, a flow
 * its write guard refuses) with 201 and `applied: false` plus the reason, not
 * an error status, so callers must read the result before saying "applied".
 * For Media Devoted | Created By Ciro Autiero
 */

export type UnpushedApplyResult = { applied?: boolean; error?: string | null } | null | undefined;

export function unpushedReason(
  result: UnpushedApplyResult,
): string | null {
  if (!result || result.applied !== false) return null;
  return result.error?.trim() || 'Nothing was pushed';
}
